
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexHWscpw9hUC9gv_451CPEWNCe_45o6A1vjLVbL_4514BiptrR0Meta } from "/var/www/html/bp-web-menu-v2-dev/pages/index.vue?macro=true";
import { default as login3lO0eE3k7n7jwVNtXZUXeiX_PUlJx9u_454TJM4MxaWEMMeta } from "/var/www/html/bp-web-menu-v2-dev/pages/login.vue?macro=true";
import { default as checkoutK4kALwXEbvCmov1OouqxPAVUQDhNT8FGRyETLtmWFRMMeta } from "/var/www/html/bp-web-menu-v2-dev/pages/checkout.vue?macro=true";
import { default as registerEWSp8g_NWa1LqN197UHFwDjWykhWJKg9cNl8YWdwaiUMeta } from "/var/www/html/bp-web-menu-v2-dev/pages/register.vue?macro=true";
import { default as indexSi6HXDQQu9q8bXHRc0dCzK_45t6dSuC6OgFBQvGPoQR_45oMeta } from "/var/www/html/bp-web-menu-v2-dev/pages/account/index.vue?macro=true";
import { default as reset_45passwordhfKbc_45ynHwplmkN5p9Wb4HM8M5O_nQ8U5dq2QzKFXdoMeta } from "/var/www/html/bp-web-menu-v2-dev/pages/reset-password.vue?macro=true";
import { default as forgot_45passwordf_45T_45fArF_45O2MvTFkcKyWFdKv7mN7lQyxakTZ3CsGTXkMeta } from "/var/www/html/bp-web-menu-v2-dev/pages/forgot-password.vue?macro=true";
import { default as addressesuMz65eNKBQcaTlDbpUwwwAXx5JRI_45Kh4ii0Dx48BQpYMeta } from "/var/www/html/bp-web-menu-v2-dev/pages/account/addresses.vue?macro=true";
import { default as indexa28yMbdgZUSrTkpmz7WCoQgbyAGC4JdRLyjwirzwtPAMeta } from "/var/www/html/bp-web-menu-v2-dev/pages/account/orders/index.vue?macro=true";
import { default as payment_45methodsKXiTjYbSP9_751LuZYpLSWa4AaekgSkXlByQYIPSjQcMeta } from "/var/www/html/bp-web-menu-v2-dev/pages/account/payment-methods.vue?macro=true";
import { default as _91orderUuid_93_45_91locationUuid_93_45_91email_93jCm_45GvMlBcj_45XG_xpPLpTDR0NNaZdLuHGC1K0VjD28MMeta } from "/var/www/html/bp-web-menu-v2-dev/pages/orders/[orderUuid]-[locationUuid]-[email].vue?macro=true";
import { default as _91orderUuid_93_45_91locationUuid_93_45_91email_930cl5lOQTIOGnu_45KDuyyfZ_45AL1zD42v1aqE9sbqwin84Meta } from "/var/www/html/bp-web-menu-v2-dev/pages/account/orders/[orderUuid]-[locationUuid]-[email].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexHWscpw9hUC9gv_451CPEWNCe_45o6A1vjLVbL_4514BiptrR0Meta || {}), ...{"middleware":["get-root-data","set-color-mode","get-shop-categories","get-structured-data"]} },
    component: () => import("/var/www/html/bp-web-menu-v2-dev/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(login3lO0eE3k7n7jwVNtXZUXeiX_PUlJx9u_454TJM4MxaWEMMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2-dev/pages/login.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: { ...(checkoutK4kALwXEbvCmov1OouqxPAVUQDhNT8FGRyETLtmWFRMMeta || {}), ...{"middleware":["get-root-data","set-color-mode","has-cart-items"]} },
    component: () => import("/var/www/html/bp-web-menu-v2-dev/pages/checkout.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: { ...(registerEWSp8g_NWa1LqN197UHFwDjWykhWJKg9cNl8YWdwaiUMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2-dev/pages/register.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: { ...(indexSi6HXDQQu9q8bXHRc0dCzK_45t6dSuC6OgFBQvGPoQR_45oMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2-dev/pages/account/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: { ...(reset_45passwordhfKbc_45ynHwplmkN5p9Wb4HM8M5O_nQ8U5dq2QzKFXdoMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in","validate-password-request"]} },
    component: () => import("/var/www/html/bp-web-menu-v2-dev/pages/reset-password.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: { ...(forgot_45passwordf_45T_45fArF_45O2MvTFkcKyWFdKv7mN7lQyxakTZ3CsGTXkMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2-dev/pages/forgot-password.vue")
  },
  {
    name: "account-addresses",
    path: "/account/addresses",
    meta: { ...(addressesuMz65eNKBQcaTlDbpUwwwAXx5JRI_45Kh4ii0Dx48BQpYMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2-dev/pages/account/addresses.vue")
  },
  {
    name: "account-orders",
    path: "/account/orders",
    meta: { ...(indexa28yMbdgZUSrTkpmz7WCoQgbyAGC4JdRLyjwirzwtPAMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2-dev/pages/account/orders/index.vue")
  },
  {
    name: "account-payment-methods",
    path: "/account/payment-methods",
    meta: { ...(payment_45methodsKXiTjYbSP9_751LuZYpLSWa4AaekgSkXlByQYIPSjQcMeta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in"]} },
    component: () => import("/var/www/html/bp-web-menu-v2-dev/pages/account/payment-methods.vue")
  },
  {
    name: "orders-orderUuid-locationUuid-email",
    path: "/orders/:orderUuid()-:locationUuid()-:email()",
    meta: { ...(_91orderUuid_93_45_91locationUuid_93_45_91email_93jCm_45GvMlBcj_45XG_xpPLpTDR0NNaZdLuHGC1K0VjD28MMeta || {}), ...{"middleware":["get-root-data","set-color-mode","get-valid-order"]} },
    component: () => import("/var/www/html/bp-web-menu-v2-dev/pages/orders/[orderUuid]-[locationUuid]-[email].vue")
  },
  {
    name: "account-orders-orderUuid-locationUuid-email",
    path: "/account/orders/:orderUuid()-:locationUuid()-:email()",
    meta: { ...(_91orderUuid_93_45_91locationUuid_93_45_91email_930cl5lOQTIOGnu_45KDuyyfZ_45AL1zD42v1aqE9sbqwin84Meta || {}), ...{"middleware":["get-root-data","set-color-mode","is-logged-in","get-valid-order"]} },
    component: () => import("/var/www/html/bp-web-menu-v2-dev/pages/account/orders/[orderUuid]-[locationUuid]-[email].vue")
  }
]